// frontend/src/components/Footer.js
import React from "react";

const Footer = () => {
  return (
    <footer className="main-footer">
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-6">
            <strong>
              <span>&copy; {new Date().getFullYear()} ระบบ SSK3 ITA</span>
            </strong>
          </div>
          <div className="col-md-6 text-md-end">
            <div>
              <img
                src="https://www.i-pic.info/i/krVq1004512.jpg"
                alt="Devtaiban Logo"
                className="me-2"
                style={{
                  width: "30px",
                  height: "30px",
                  borderRadius: "50%",
                  marginLeft: "5px",
                }}
              />
              พัฒนาโดย{" "}
              <a
                href="http://www.Kruwirat.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                www.Kruwirat.com
              </a>
              {" / "}
              <a href="tel:095-602-9737">tel 095-602-9737</a>
            </div>
            <div></div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
